import { PostGroupsType } from '../../../../models/post-editor';
import { ActiveCustomizeIndexType } from '../../states/ActiveCustomizeIndexProvider';

export const getCustomizationProfileId = (
  group: PostGroupsType,
  customizeIndex: ActiveCustomizeIndexType
): string | null | undefined => {
  const { customizeSchedulePerProfile, customizeContentPerProfile, posts } = group;
  if (customizeSchedulePerProfile || customizeContentPerProfile) {
    return typeof customizeIndex === 'number' ? posts[customizeIndex].customizedProfileId : undefined;
  }
  return null;
};
